import(/* webpackMode: "eager" */ "/app/app/[locale]/_debugger.tsx");
import(/* webpackMode: "eager" */ "/app/app/global.css");
import(/* webpackMode: "eager" */ "/app/component/block/cookieHint/cookieHint.tsx");
import(/* webpackMode: "eager" */ "/app/component/providers.tsx");
import(/* webpackMode: "eager" */ "/app/lib/polyfills.ts");
import(/* webpackMode: "eager" */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
import(/* webpackMode: "eager" */ "/app/store/server-context/store-initializer.ts")